
import { Tent, MapPin, FileVideo } from 'lucide-react';
import BrandPillar from '@/components/ui-custom/BrandPillar';

const ExodusExperienceSection = () => {
  return (
    <section className="section-padding">
      <div className="container-custom">
        <div className="text-center mb-12">
          <h2 className="heading-lg text-adv-dark mb-4 animate-fade-in">The Exodus Experience</h2>
          <p className="text-adv-darkGray max-w-2xl mx-auto animate-fade-in">
            More than just rides and rallies — we're building a movement for adventure motorcycle enthusiasts.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          <BrandPillar
            icon={Tent}
            title="ADV Rallies"
            description="Epic events held throughout the year. Camp, ride, and connect with the ADV community."
            linkTo="/rallies"
            linkText="Explore Rallies"
          />
          <BrandPillar
            icon={MapPin}
            title="Explore Rides"
            description="Find local group rides, create communities, and discover new adventures near you."
            linkTo="/explore-rides"
            linkText="Find a Ride"
          />
          <BrandPillar
            icon={FileVideo}
            title="Content Garage"
            description="Watch ride videos, learn, and enjoy ADV in your downtime."
            linkTo="/content-garage"
            linkText="Browse Content"
          />
        </div>
      </div>
    </section>
  );
};

export default ExodusExperienceSection;
